import { Box, IconButton, TextField } from "@material-ui/core";
import { Edit as EditIcon } from "@material-ui/icons";
import { Save as SaveIcon } from "@material-ui/icons";
import { Cancel as CancelIcon } from "@material-ui/icons";
import React from "react";

export interface SelfEditableTextFieldProps {
  value?: string;
  readOnlyComponent?: React.ReactNode;
  onChange: (value: string) => void;
}

const SelfEditableTextField: React.FC<SelfEditableTextFieldProps> = ({ value, readOnlyComponent, onChange }) => {
  const [isEditing, setIsEditing] = React.useState(false);
  const [newValue, setNewValue] = React.useState(value ?? "");

  const content = isEditing ? (
    <TextField
      autoFocus={true}
      fullWidth={true}
      onChange={(e) => setNewValue(e.target.value)}
      value={newValue}
      required={false}
      disabled={false}
    />
  ) : (
    <>{readOnlyComponent}</>
  );

  const handleSave = () => {
    setIsEditing(false);
    onChange(newValue);
  };

  return (
    <Box display="flex" alignItems="center">
      {content}
      {isEditing ? (
        <Box>
          <IconButton onClick={handleSave} size="small" style={{ marginLeft: 8 }}>
            <SaveIcon />
          </IconButton>
          <IconButton onClick={() => setIsEditing(!isEditing)} size="small" style={{ marginLeft: 8 }}>
            <CancelIcon />
          </IconButton>
        </Box>
      ) : (
        <IconButton onClick={() => setIsEditing(!isEditing)} size="small" style={{ marginLeft: 8 }}>
          <EditIcon />
        </IconButton>
      )}
    </Box>
  );
};

SelfEditableTextField.defaultProps = {
  onChangeIsValid: () => {},
  required: false,
} as Partial<SelfEditableTextFieldProps>;

export default SelfEditableTextField;
